<template>
  <div class="rb-center-content">
    <div class="rb-popup-body" v-html="data.body"></div>
  </div>
</template>
<script>
/**
 * Static Popup
 *
 * @summary
 * Data is created through customizer
 *
 * @props
 * data: Object
 */
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
